import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { getLanguageFromUrl } from 'shared/helpers/parseUrl';
import { Key } from 'i18n/Key';

import en from 'i18n/translations/en.json';
import sen from 'i18n/translations/sen.json';
import de from 'i18n/translations/de.json';
import fr from 'i18n/translations/fr.json';
import it from 'i18n/translations/it.json';
import ru from 'i18n/translations/ru.json';
import sv from 'i18n/translations/sv.json';
import tr from 'i18n/translations/tr.json';
import ro from 'i18n/translations/ro.json';
import bg from 'i18n/translations/bg.json';
import cs from 'i18n/translations/cs.json';
import hr from 'i18n/translations/hr.json';
import nl from 'i18n/translations/nl.json';
import pt from 'i18n/translations/pt.json';
import fi from 'i18n/translations/fi.json';
import no from 'i18n/translations/no.json';
import el from 'i18n/translations/el.json';
import uk from 'i18n/translations/uk.json';
import es from 'i18n/translations/es.json';

export const DEFAULT_NS = 'translation';
export const DEFAULT_LANG = 'en';

const resources = {
  en: {
    [DEFAULT_NS]: en,
  },
  sen: {
    [DEFAULT_NS]: sen,
  },
  de: {
    [DEFAULT_NS]: de,
  },
  fr: {
    [DEFAULT_NS]: fr,
  },
  it: {
    [DEFAULT_NS]: it,
  },
  ru: {
    [DEFAULT_NS]: ru,
  },
  sv: {
    [DEFAULT_NS]: sv,
  },
  tr: {
    [DEFAULT_NS]: tr,
  },
  ro: {
    [DEFAULT_NS]: ro,
  },
  bg: {
    [DEFAULT_NS]: bg,
  },
  cs: {
    [DEFAULT_NS]: cs,
  },
  hr: {
    [DEFAULT_NS]: hr,
  },
  nl: {
    [DEFAULT_NS]: nl,
  },
  pt: {
    [DEFAULT_NS]: pt,
  },
  fi: {
    [DEFAULT_NS]: fi,
  },
  no: {
    [DEFAULT_NS]: no,
  },
  el: {
    [DEFAULT_NS]: el,
  },
  uk: {
    [DEFAULT_NS]: uk,
  },
  es: {
    [DEFAULT_NS]: es,
  },
};

i18n.use(initReactI18next).init({
  resources: resources,
  lng: getLanguageFromUrl(),
  fallbackLng: DEFAULT_LANG,
  interpolation: {
    escapeValue: false,
  },
});

export const addDefaultTranslates = (
  trans: { [key in keyof typeof Key]?: string },
) => {
  const defaultTrans = i18n.getResourceBundle(DEFAULT_LANG, DEFAULT_NS);
  Object.entries(trans).forEach(([key, img]) => {
    if (!defaultTrans[img])
      i18n.addResources(DEFAULT_LANG, DEFAULT_NS, { [key]: img });
  });
};
